// Battlefield (mobile/tablet) plan page layout with bottom panel tabs.
import { Box } from '@mui/material';
import PlanPagePanelTabs from '@/features/planning/components/shared/PlanPagePanelTabs';

export function PlanPageBattlefieldLayout({
  renderView,
  overdueTasks,
  nextActions,
  unscheduledTasks,
  overdueRailSlice,
  nextActionRailSlice,
  selectedTaskIds,
  railSelectionHandlers,
  focusOwnerId,
  plannedParentIds,
  waitingForParentIds,
  tasksMap,
  onboardingHighlightTaskId = null,
  onboardingHighlightAddTask = false,
  onOnboardingAddTaskUsed,
}) {
  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
      }}
    >
      <Box
        sx={{
          flex: 1,
          minHeight: 240,
          minWidth: 0,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {renderView()}
      </Box>
      <PlanPagePanelTabs
        overdueTasks={overdueTasks}
        nextActions={nextActions}
        unscheduledTasks={unscheduledTasks}
        overdueRailSlice={overdueRailSlice}
        nextActionRailSlice={nextActionRailSlice}
        selectedTaskIds={selectedTaskIds}
        railSelectionHandlers={railSelectionHandlers}
        focusOwnerId={focusOwnerId}
        plannedParentIds={plannedParentIds}
        waitingForParentIds={waitingForParentIds}
        tasksMap={tasksMap}
        onboardingHighlightTaskId={onboardingHighlightTaskId}
        onboardingHighlightAddTask={onboardingHighlightAddTask}
        onOnboardingAddTaskUsed={onOnboardingAddTaskUsed}
      />
    </Box>
  );
}
